import {
  Badge,
  BADGE_COLOR_VARIANTS,
} from '@bambi/component-library/src/components/Badge/Badge';
import { Popover } from '@bambi/component-library/src/components/Popover/Popover';

import {
  IntermediaryEnum,
  TripListRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
type TripImportedBadgeProps = {
  trip: TripRead | TripListRead;
};

export const TripImportedBadge: React.FC<TripImportedBadgeProps> = ({
  trip,
}) => {
  const {
    one_schema_template_id,
    one_schema_template_multi_id,
    external_trip_id,
    intermediary_id,
  } = trip;
  if (
    one_schema_template_id ||
    one_schema_template_multi_id ||
    intermediary_id
  ) {
    const source = getSource(trip);

    return (
      <Popover
        trigger={
          <div className="cursor-pointer">
            <Badge label="Imported" color={BADGE_COLOR_VARIANTS.GREEN} />
          </div>
        }
        content={
          <div className="m-[-10px] text-sm">
            <div>
              <span className="font-bold">Source:</span> {source}
            </div>
            <div>
              <span className="font-bold">External Trip ID:</span>{' '}
              {external_trip_id || intermediary_id}
            </div>
          </div>
        }
      ></Popover>
    );
  }

  return null;
};

const getSource = (trip: TripRead | TripListRead) => {
  if (trip.one_schema_template_id || trip.one_schema_template_multi_id) {
    return 'CSV';
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const intermediary = trip.intermediary ?? '';
  if (intermediary !== '') {
    return intermediaryDisplayName(intermediary);
  }
  return 'Kinetik';
};

const intermediaryDisplayNameMap: Record<IntermediaryEnum, string> = {
  alivi: 'Alivi',
  call_the_car: 'Call The Car',
  kinetik: 'Kinetik',
  momentm: 'Momentm',
  mtm: 'MTM',
  cts: 'CTS',
  welltrans: 'Welltrans',
  verida: 'Verida',
  provide_a_ride: 'Provide A Ride',
  tennessee_carriers: 'Tennessee Carriers',
  clearview: 'Clearview',
  vectorcare: 'VectorCare',
};

export const intermediaryDisplayName = (intermediary: IntermediaryEnum) => {
  if (intermediary in intermediaryDisplayNameMap) {
    return intermediaryDisplayNameMap[intermediary];
  }
  return intermediary;
};
